<template>
  <div class="table-content">
    <div class="header">
      <div class="tab-list">
        <el-tabs v-model="payType" @tab-click="onTabChange">
          <el-tab-pane name="wait" v-if="funcView.account_my_account_list" :label="$t('device_bill_dai_zhi_fu')"></el-tab-pane>
          <el-tab-pane name="paid" v-if="funcView.account_my_account_list" :label="$t('device_bill_yi_zhi_fu')"></el-tab-pane>
          <el-tab-pane name="shouldRefund" v-if="funcView.account_invoice_list" :label="$t('device_bill_ying_tui_kuan')"></el-tab-pane>
          <el-tab-pane name="hasRefund" v-if="funcView.account_invoice_list" :label="$t('device_bill_yi_tui_kuan')"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="query-filter">
      <div class="params-form" v-if="payType === 'wait' || payType === 'paid'">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_fkdqsj') }}</div>
              <div class="value">
                <custom-date-picker
                  v-model="formSearch.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :start-placeholder="$t('device_bill_kai_shi_shi_jian')"
                  :end-placeholder="$t('device_bill_jie_shu_shi_jian')"
                  @change="onDateChange"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :pickerOptions="null"
                  :init-value="initDate"
                ></custom-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_xiang_mu') }}</div>
              <div class="value">
                <el-input v-model="formSearch.locationName" @input="onLocationChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_skgs') }}</div>
              <div class="value">
                <el-input v-model="formSearch.receivableOrgName" @input="onCompanyChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="params-form" v-else>
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_xiang_mu_1') }}</div>
              <div class="value">
                <el-input v-model="formSearch.locationName" @input="onLocationChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_fu_kuan_gong_si') }}</div>
              <div class="value">
                <el-input v-model="formSearch.payableOrgName" @input="onCompanyChange2" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_bill_tksj') }}</div>
              <div class="value">
                <custom-date-picker
                  v-model="formSearch.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :start-placeholder="$t('device_bill_kai_shi_shi_jian_1')"
                  :end-placeholder="$t('device_bill_jie_shu_shi_jian_1')"
                  @change="onDateChange"
                  value-format="YYYY-MM-DD HH:mm:ss"
                ></custom-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('device_bill_shai_xuan_xiang') }}：</div>
        <div class="values">
          <el-tag closable v-for="dateTag in dateTagList" :key="dateTag.value" @close="onCloseTime(dateTag.value)">{{ dateTag.label }}</el-tag>
          <el-tag closable v-for="locationNameTag in locationNameTagList" :key="locationNameTag.value" @close="onCloseLocationName(locationNameTag.value)">{{ locationNameTag.label }}</el-tag>
          <el-tag closable v-for="companyTag in companyTagList" :key="companyTag.value" @close="onCloseCompanyName(companyTag.value)">{{ companyTag.label }}</el-tag>
          <el-button type="info" size="mini" @click="onClear">{{ $t('com_clear') }}</el-button>
        </div>
      </div>
    </div>
    <div class="search-content">
      <div class="btn-content">
        <!-- portal中，交易状态为 billTradeState 0-未交易时，才能确认付款（登记付款） -->
        <!-- 登记付款 -->
        <el-button
          type="warning"
          v-if="funcView.account_confirm_payment && payType === 'wait'"
          @click="payRegister(selectedData)"
          :disabled="!payConfirmVisible(selectedData) || !selectedData.length || !funcView.account_confirm_payment"
        >
        {{ $t('device_bill_que_ren_fu_kuan') }}
        </el-button>
        <!-- 开票申请 -->
        <el-button
          @click="onInvoiceApply(selectedData)"
          type="info"
          v-if="funcView.account_invoice_apply && (payType === 'paid' || payType === 'wait')"
          :disabled="!checkAuth(selectedData, 'INVOICE') || !selectedData.length"
        >
        {{ $t('device_bill_sqkp') }}
        </el-button>
      </div>
      <el-form :inline="true" @submit.native.prevent class="fr">
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right" v-if="((payType === 'paid' || payType === 'wait')&&funcView.account_my_account_export)||((payType === 'shouldRefund' || payType === 'hasRefund')&&funcView.account_apply_export)">
          <el-button type="info">
            <i class="icon icon-export-excel"></i>
            {{ $t('com_export') }} Excel
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="payType === 'wait' || payType === 'paid' ? $t('device_bill_sbhhtbh') : $t('device_bill_htbhjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-bd">
      <custom-table
        :key="payType"
        v-model="selectedData"
        :tableCode="tableCode"
        type="checkbox"
        height="100%"
        :stripe="true"
        :data="tableList"
        @column="setColumn"
        columnRef="column"
        :slots="['isDelay', 'termNum', 'totalAmount', 'action']"
        @filter="filterChange"
        @sort="sortChange"
      >
        <template v-slot:termNum="scope">
          <div>{{ formatTermNum(scope.row) }}</div>
        </template>
        <template v-slot:totalAmount="scope">
          {{ getPayTotal(scope.row) }}
        </template>
        <template v-slot:isDelay="scope">
          {{ getUrgentView(scope.row) }}
        </template>
        <template v-slot:action="scope">
          <!-- 待支付 -->
          <span class="action-content" v-if="payType === 'wait'">
            <!-- portal中，交易状态为0-未交易时，才能确认付款（登记付款） -->
            <el-button v-if="funcView.account_confirm_payment && payConfirmVisible(scope.row)" type="text" size="mini" @click="payRegister(scope.row)">
              {{ $t('device_bill_que_ren_fu_kuan_1') }}
            </el-button>
            <el-dropdown v-if="checkAuth(scope.row, 'INVOICE') && invoiceDetailVisible(scope.row) && funcView.account_invoice_apply && funcView.account_invoice_detail">
              <span class="el-dropdown-more">
                {{ $t('device_bill_geng_duo') }}
                <i class="icon icon-xiala"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="onInvoiceApply(scope.row)">{{ $t('device_bill_sqkp_1') }}</el-dropdown-item>
                <el-dropdown-item @click.native="checkInvoiceDetail(scope.row)">{{ $t('device_bill_zha_kan_fa_piao') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <template v-else>
              <el-button v-if="checkAuth(scope.row, 'INVOICE') && funcView.account_invoice_apply" type="text" size="mini" @click.native="onInvoiceApply(scope.row)">
                {{ $t('device_bill_sqkp_2') }}
              </el-button>
              <el-button v-if="invoiceDetailVisible(scope.row) && funcView.account_invoice_detail" type="text" size="mini" @click.native="checkInvoiceDetail(scope.row)">
                {{ $t('device_bill_zha_kan_fa_piao_1') }}
              </el-button>
            </template>
          </span>
          <!-- 已支付 -->
          <span class="action-content" v-if="payType === 'paid'">
            <!-- 查看付款 -->
            <el-button type="text" size="mini" v-if="funcView.account_check_payment_record && checkAuth(scope.row, 'CHECK_PAYMENT_INFO')" @click="checkPaymentInfo(scope.row)">
              {{ $t('device_bill_fkxq') }}
            </el-button>
            <el-dropdown v-if="checkAuth(scope.row, 'INVOICE') && invoiceDetailVisible(scope.row) && funcView.account_invoice_apply && funcView.account_invoice_detail">
              <span class="el-dropdown-more">
                {{ $t('device_bill_geng_duo_1') }}
                <i class="icon icon-xiala"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="funcView.account_invoice_apply && checkAuth(scope.row, 'INVOICE')" @click.native="onInvoiceApply(scope.row)">
                  {{ $t('device_bill_sqkp_3') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="funcView.account_invoice_detail && invoiceDetailVisible(scope.row)" @click.native="checkInvoiceDetail(scope.row)">
                  {{ $t('device_bill_zha_kan_fa_piao_2') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <template v-else>
              <el-button v-if="funcView.account_invoice_apply && checkAuth(scope.row, 'INVOICE')" type="text" size="mini" @click.native="onInvoiceApply(scope.row)">
                {{ $t('device_bill_sqkp_4') }}
              </el-button>
              <el-button v-if="funcView.account_invoice_detail && invoiceDetailVisible(scope.row)" type="text" size="mini" @click.native="checkInvoiceDetail(scope.row)">
                {{ $t('device_bill_zha_kan_fa_piao_3') }}
              </el-button>
            </template>
          </span>
          <!-- 应退款 -->
          <!-- <span
            class="action-content"
            v-if="payType === 'shouldRefund' && funcView.account_check_refund_msg"
          >
            <el-button
              type="text"
              size="mini"
              @click="watchRefundRecord(scope.row)"
            >查看退款</el-button>
          </span> -->
          <!-- 已退款 -->
          <span class="action-content" v-if="payType === 'hasRefund' && funcView.account_check_refund_msg">
            <el-button type="text" size="mini" @click="watchRefundRecord(scope.row)">{{ $t('device_bill_zha_kan_tui_kuan') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="page-footer">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
    </div>
    <invoice-apply-dialog v-if="invoiceApplyVisible" @close="invoiceApplyVisible = false" :model="inoviceApplyModel" @success="onPageChange({ page: 1 })"></invoice-apply-dialog>
    <refund-record-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></refund-record-dialog>
    <invoice-record-dialog v-if="invoiceRecordVisible" @close="invoiceRecordVisible = false" :model="invoiceRecordModel"></invoice-record-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import invoiceRecordDialog from '@/components/invoiceRecordDialog';
import mixins from './mixins';
import invoiceApplyDialog from './invoice_apply_dialog.vue';
import refundRecordDialog from './refund_record_dialog.vue';

// device_bill_fkdqsj: 付款到期时间// device_bill_xiang_mu: 项目// device_bill_skgs: 收款公司// device_bill_xiang_mu_1: 项目// device_bill_fu_kuan_gong_si: 付款公司// device_bill_tksj: 退款时间// device_bill_shai_xuan_xiang: 筛选项// device_bill_que_ren_fu_kuan: 确认付款// device_bill_sqkp: 申请开票// device_bill_que_ren_fu_kuan_1: 确认付款// device_bill_geng_duo: 更多// device_bill_sqkp_1: 申请开票// device_bill_zha_kan_fa_piao: 查看发票// device_bill_sqkp_2: 申请开票// device_bill_zha_kan_fa_piao_1: 查看发票// device_bill_fkxq: 付款详情// device_bill_geng_duo_1: 更多// device_bill_sqkp_3: 申请开票// device_bill_zha_kan_fa_piao_2: 查看发票// device_bill_sqkp_4: 申请开票// device_bill_zha_kan_fa_piao_3: 查看发票// device_bill_zha_kan_tui_kuan: 查看退款// device_bill_dai_zhi_fu: 待支付// device_bill_yi_zhi_fu: 已支付// device_bill_ying_tui_kuan: 应退款// device_bill_yi_tui_kuan: 已退款// device_bill_kai_shi_shi_jian: 开始时间// device_bill_jie_shu_shi_jian: 结束时间// device_bill_kai_shi_shi_jian_1: 开始时间// device_bill_jie_shu_shi_jian_1: 结束时间// device_bill_sbhhtbh: 设备号/合同编号// device_bill_htbhjsh: 合同编号/机身号// device_bill_fa_piao_ji_lu: 发票记录// device_bill_sqkp_5: 申请开票

export default {
  name: 'deviceBill',
  mixins: [mixins],
  components: {
    invoiceApplyDialog,
    refundRecordDialog,
    invoiceRecordDialog,
  },
  props: {},
  data() {
    return {
      // 支付类型: 待支付：wait  已支付：paid  应退款：shouldRefund  已退款：hasRefund
      payType: 'wait',
      formSearch: {
        keyword: '',
        pageSize: 50,
        pageNum: 1,
        time: '',
        locationName: '',
        receivableOrgName: '',
        payableOrgName: '',
      },
      totalRows: 0,
      tableList: [],
      selectedData: [],
      dateTagList: [],
      locationNameTagList: [],
      companyTagList: [],
      invoiceApplyVisible: false,
      inoviceApplyModel: {},
      // invoiceDetailsVisible: false,
      // invoiceDetailsModel: {},
      dialogVisible: false,
      dialogModel: {},
      invoiceRecordModel: {},
      invoiceRecordVisible: false,
      initDate: '',
    };
  },
  computed: {
    tableCode() {
      const map = {
        wait: 'portal_device_bill_wait',
        paid: 'portal_device_bill_paid',
        shouldRefund: 'portal_device_bill_s_return',
        hasRefund: 'portal_device_bill_has_return',
      };
      const type = this.payType;
      return map[type];
    },
  },
  methods: {
    setInitDate() {
      if (this.payType === 'wait') {
        this.initDate = [`${this.$moment().format('YYYY-MM-DD')} 00:00:00`, `${this.$moment().add(3, 'months').format('YYYY-MM-DD')} 23:59:59`];
      } else {
        this.initDate = [`${this.$moment().subtract(3, 'months').format('YYYY-MM-DD')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];
      }
    },
    onTabChange() {
      const payType = this.payType;
      if (['shouldRefund', 'hasRefund'].includes(payType)) {
        this.onClear();
      } else {
        this.clearData();
        // 123. 待支付，付款到期时间-结束时间默认当前日期后3个月，按付款到期时间正序排；已支付 付款到期时间-开始时间默认当前日期前3个月，付款到期时间倒序排

        this.setInitDate();

        setTimeout(() => {
          this.formatDateTag();
          this.onPageChange({ page: 1 });
        }, 100);
      }
    },
    i18nCallback() {
      // this.payType = 'wait';
    },
    // 查看退款信息
    watchRefundRecord: function (row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      const id = this.getUUID();
      this.setSession(id, rows);
      this.jump('/rent/myAccount/refundDetail', {
        id,
      });
      // this.dialogModel.type = 'watch';
      // this.dialogModel.title = '退款详情';
      // this.dialogModel.row = row;
      // this.dialogVisible = true;
    },
    // 判断是否允许查看发票
    invoiceDetailVisible(row) {
      // 字典：invoice_wait_state  待提交：1  已提交：2
      return !!row.invoiceAmount;
    },

    // 查看发票
    checkInvoiceDetail(row) {
      this.invoiceRecordModel = {
        title: this.$t('device_bill_fa_piao_ji_lu'),
        type: row.isRedInvoice,
        billId: row.billId,
      };
      this.invoiceRecordVisible = true;
    },
    payConfirmVisible(row) {
      const arr = Array.isArray(row) ? [...row] : [row];
      return !arr.some(item => item.billTradeState !== 0);
    },
    onInvoiceApply(row) {
      this.inoviceApplyModel = {
        row: row,
        title: this.$t('device_bill_sqkp_5'),
      };
      this.invoiceApplyVisible = true;
    },
    getReqData() {
      // 根据payType转换对应额billTradeState
      const billTradeStateMap = {
        wait: [0],
        paid: [10, 11, 90, 100],
        shouldRefund: [0, 1, 6],
        hasRefund: [10, 90, 100],
      };
      const ret = {
        ...this.formSearch,
      };

      delete ret.time;

      const startDate = this.formSearch.time[0] ? this.formSearch.time[0] : null;
      const endDate = this.formSearch.time[1] ? this.formSearch.time[1] : null;

      if (this.payType === 'wait') {
        ret.paymentTimeAsc = true;
      }

      if (this.payType === 'paid') {
        ret.paymentTimeAsc = false;
      }

      if (this.payType === 'wait' || this.payType === 'paid') {
        // ret.billType = 10;
        if (this.formSearch.time && this.formSearch.time.length) {
          ret.billPaymentTime = [startDate, endDate];
        }
      } else {
        if (this.formSearch.time && this.formSearch.time.length) {
          ret.beginOfTermStartTime = startDate;
          ret.endOfTermStartTime = endDate;
        }
      }

      if (!(ret.billTradeState && ret.billTradeState.length)) {
        ret.billTradeState = billTradeStateMap[this.payType];
      }

      return ret;
    },
    getReqUrl() {
      if (['wait', 'paid'].includes(this.payType)) {
        return apis.portalPayableBillPage;
      }
      return apis.portalPayableBillRefundPage;
    },
    onLocationChange() {
      const locationName = this.formSearch.locationName.trim();
      if (locationName) {
        this.locationNameTagList = [
          {
            label: locationName,
            value: 'company',
          },
        ];
      } else {
        this.locationNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseLocationName() {
      this.formSearch.locationName = '';
      this.onLocationChange();
    },
    onCompanyChange() {
      const receivableOrgName = this.formSearch.receivableOrgName.trim();
      if (receivableOrgName) {
        this.companyTagList = [
          {
            label: receivableOrgName,
            value: 'receivableOrgName',
          },
        ];
      } else {
        this.companyTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCompanyChange2() {
      const payableOrgName = this.formSearch.payableOrgName.trim();
      if (payableOrgName) {
        this.companyTagList2 = [
          {
            label: payableOrgName,
            value: 'payableOrgName',
          },
        ];
      } else {
        this.companyTagList2 = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseCompanyName() {
      this.formSearch.receivableOrgName = '';
      this.onCompanyChange();
    },
    clearData() {
      this.dateTagList = [];
      this.locationNameTagList = [];
      this.companyTagList = [];
      this.companyTagList2 = [];
      this.formSearch.time = [];
      this.formSearch.initDate = '';
      this.formSearch.locationName = '';
      this.formSearch.receivableOrgName = '';
      this.formSearch.payableOrgName = '';
      this.formSearch.billType = [];
    },
    onClear() {
      this.clearData();
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    formatDateTag() {
      const data = this.formSearch.time;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.dateTagList = [
          {
            label: `${start}~${end}`,
            value: 'date',
          },
        ];
      } else {
        this.dateTagList = [];
      }
    },
    onDateChange() {
      this.formatDateTag();
      this.onPageChange({ page: 1 });
    },
    onCloseTime() {
      this.formSearch.time = [];
      this.onDateChange();
    },
    getTableList() {
      const reqData = this.getReqData();
      const url = this.getReqUrl();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = res.data.list || res.data.records;
        this.totalRows = res.data.total;
      });
    },
  },
  created() {},
  mounted() {
    this.mergeLanguage(null, 'portal_device_bill');
    this.setInitDate();
    this.getFuncView('/rent/myAccount');
    setTimeout(() => {
      this.formatDateTag();
      this.getTableList();
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.table-content {
  border-radius: 16px;
  background: #fff;
  > .header {
    padding: 24px;
    overflow: hidden;
    padding-bottom: 0;
  }

  .query-filter {
    padding-top: 0;
  }

  .search-content {
    padding: 0 24px;
    overflow: hidden;
    .btn-content {
      float: left;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }

  .table-bd {
    height: 416px;
    width: 100%;
    overflow: hidden;
    padding: 0 24px;
  }
}
</style>
